// src/components/select/recipe.ts
import { tv } from "tailwind-variants";
var selectSlotRecipe = tv({
  slots: {
    root: ["flex", "w-full", "flex-col", "gap-2"],
    label: [
      "mx-0",
      "p-0",
      "text-foreground",
      "my-label-sm",
      "data-[disabled]:opacity-50",
      "data-[disabled]:cursor-not-allowed"
    ],
    control: ["relative", "data-[disabled]:opacity-50"],
    trigger: [
      "flex",
      "w-full",
      "select-none",
      "items-center",
      "justify-between",
      "rounded-md",
      "px-3",
      "text-start",
      "focus-visible:outline-focus",
      "data-[placeholder-shown]:text-foreground-disabled",
      "data-[disabled]:cursor-not-allowed",
      "data-[invalid]:border-semantic-critical"
    ],
    indicatorGroup: [
      "pointer-events-none",
      "absolute",
      "bottom-0",
      "right-0",
      "top-0",
      "flex",
      "items-center",
      "px-3",
      "gap-2"
    ],
    clearTrigger: ["pointer-events-auto", "[&>svg]:w-4", "[&>svg]:h-4"],
    indicator: ["[&>svg]:w-5", "[&>svg]:h-5"],
    valueText: ["line-clamp-1", "max-w-[80%]"],
    content: [
      "max-h-[300px]",
      "overflow-y-auto",
      "rounded-md",
      "bg-interactive-subtle-surface",
      "shadow-[0px_8px_16px_rgb(0_0_0_/_0.1),_0px_0px_1px_rgb(206_206_206)]",
      "outline-none",
      "data-[state=closed]:duration-75",
      "data-[state=open]:animate-in",
      "data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out",
      "data-[state=open]:fade-in",
      "data-[state=closed]:slide-out-to-top-2",
      "data-[state=open]:slide-in-from-top-2"
    ],
    item: [
      "relative",
      "flex",
      "cursor-pointer",
      "justify-between",
      "px-3",
      "py-2",
      "data-[disabled]:cursor-default",
      "data-[highlighted]:bg-interactive-subtle-surface-hover",
      "data-[disabled]:opacity-50"
    ],
    itemIndicator: [
      "data-[state=checked]:flex",
      "data-[state=checked]:items-center",
      "data-[state=checked]:justify-center",
      "[&>svg]:w-5",
      "[&>svg]:h-5"
    ]
  },
  variants: {
    size: {
      sm: {
        trigger: ["min-h-9", "my-body-sm"],
        content: ["my-body-sm"]
      },
      md: {
        trigger: ["min-h-10", "my-body-md"],
        content: ["my-body-md"]
      },
      lg: {
        trigger: ["min-h-11", "my-body-md"],
        content: ["my-body-md"]
      },
      xl: {
        trigger: ["min-h-12", "my-body-lg"],
        content: ["my-body-lg"]
      }
    },
    variant: {
      outline: {
        trigger: ["border"]
      },
      subtle: {
        trigger: ["bg-interactive-surface"]
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

export {
  selectSlotRecipe
};
